// extracted by mini-css-extract-plugin
export default {"editable":"teacher-note_editable__0YZLR"};